import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CheckInsGroupsOptions, LocalStorageKeys, TimestampSortOptions, WarehouseCheckInColumnHeader } from "src/enums";
import { WarehouseCheckInsFilters } from "src/types";

class WarehouseCheckInDashService extends DashboardService<
  WarehouseCheckInColumnHeader,
  WarehouseCheckInsFilters,
  TimestampSortOptions,
  CheckInsGroupsOptions
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.WAREHOUSE_CHECK_IN_DASH_SETTINGS);
  }
}

export { WarehouseCheckInDashService };
